import React, { useEffect } from 'react';
import { Button, Form, Message } from 'semantic-ui-react';
import { useForm } from 'react-hook-form';
import { useAppContext } from '../../context/AppContext';

import './login.scss';

const Login = () => {
  const { actions } = useAppContext();

  const { handleSubmit, register, errors, triggerValidation, setValue } = useForm();  

  const onSubmitForm = (data, e) => {
    e.preventDefault();
    actions.login(data);
  };

  useEffect(() => {
    register({ name: "username" }, { required: 'Champs requis' });
    register({ name: "password" }, { required: 'Champs requis' });
  }, []);

  return (

    <div id="login">
      <div className="login-block">
        <div className="login-block-title">
          <h2>VOUS CONNECTER</h2>
          <h3>Entrez vos informations</h3>
        </div>
        
        <div className="form">
          <Form 
            onSubmit={handleSubmit(onSubmitForm)}
            error={errors.username || errors.password ? true : false}
          >
            <Form.Group widths='equal'>
              <Form.Input
                placeholder="Username"
                onChange={async (e, {name, value}) => {
                  setValue(name, value)
                  await triggerValidation({ name })
                }}
                name="username"
                error={errors.username ? true : false}
              />
              

              <Form.Input
                placeholder="Mot de Passe"
                type="password"
                onChange={async (e, {name, value}) => {
                  setValue(name, value)
                  await triggerValidation({ name })
                }}
                name="password"
                error={errors.password ? true : false}
              />
            </Form.Group>

            <Message
              error
              icon='warning circle'
              content="Veuillez remplir tous les champs"
            />

            <Button className="cstm-btn" type="submit">Submit</Button>

          </Form>
        </div>
      </div>
    </div>

  );
}

export default Login;
